// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3de87b5f","363":"087ed17e","616":"93c77bb9","860":"aea7f453"}[chunkId] + ".chunk.js";
};